module.exports = __webpack_public_path__ + "img/ic-lock.f2e033e7.svg";